<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ (currentArticle ? "EDIT" : "ADD_WARRANTY_ARTICLE") | translate }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss()"
  ></button>
</div>

<div class="modal-body p-3">
  <div class="row mx-0">
    <div class="col-12 col-sm-7 ps-0 pe-4 mx-0">
      <div class="left-container h-100 p-4">
        <h5>{{ "MAKE_A_CHOICE" | translate }}</h5>
        <div class="btn-group btn-group-toggle py-2 d-flex gap-2">
          <button
            class="btn"
            (click)="switch('GAR')"
            [ngClass]="tabTypeSelected === 'GAR' ? 'btn-dark' : 'btn-primary'"
            >
            {{ descriptions["GAR"] | translate }}
          </button>
          <button
            class="btn"
            (click)="switch('WDL')"
            [ngClass]="tabTypeSelected === 'WDL' ? 'btn-dark' : 'btn-primary'"
            >
            {{ descriptions["WDL"] | translate }}
          </button>
          @if (hasLease) {
            <button
              class="btn"
              (click)="switch('LEASE')"
              [ngClass]="tabTypeSelected === 'LEASE' ? 'btn-dark' : 'btn-primary'"
              >
              {{ "LEASE" | translate }}
            </button>
          }
          <button
            class="btn"
            (click)="switch('REC')"
            [ngClass]="tabTypeSelected === 'REC' ? 'btn-dark' : 'btn-primary'"
            >
            {{ descriptions["REC"] | translate }}
          </button>
          <!-- hide button 25-09-2023, since no longer active
          <button
            class="btn"
            (click)="switch('REC_BATT')"
            [ngClass]="
              tabTypeSelected === 'REC_BATT' ? 'btn-dark' : 'btn-primary'
            "
            >
            {{ descriptions["REC_BATT"] | translate }}
          </button>
          -->
        </div>
        <form [formGroup]="formGroup" [ngClass]="validated ? 'validated' : ''">
          <!-- GUARANTEE -->
          @if (tabTypeSelected === 'GAR') {
            <app-warranty-guarantee
              #guarantee
              [warrantyId]="warrantyId"
              [currentArticle]="currentArticle"
              (bicycleSelect)="this.bicycle = $event"
              (typeChange)="setReasonId($event)"
              [hasLease]="hasLease"
              (partSelect)="selectPart($event)"
              [formGroup]="formGroup"
              >
            </app-warranty-guarantee>
          }

          <!-- RETURNS -->
          @if (tabTypeSelected === 'WDL') {
            <app-warranty-returns
              #returns
              [currentArticle]="currentArticle"
              (partSelect)="selectPart($event)"
              [warrantyId]="warrantyId"
              (typeChange)="setReasonId($event)"
              [formGroup]="formGroup"
            ></app-warranty-returns>
          }

          <!-- CALLBACK -->
          @if (tabTypeSelected === 'REC') {
            <app-warranty-callback
              #callback
              [currentArticle]="currentArticle"
              (bicycleSelect)="this.bicycle = $event"
              (partSelect)="this.part = $event"
              [formGroup]="formGroup"
              [tabSelected]="tabTypeSelected"
            ></app-warranty-callback>
          }

          <!-- LEASING -->
          @if (tabTypeSelected === 'LEASE') {
            <app-warranty-leasing
              #leasing
              [formGroup]="formGroup"
              [bicycle]="bicycle"
              [warrantyId]="warrantyId"
              [currentArticle]="currentArticle"
              (getContent)="getExplanation($event)"
              (bicycleSelect)="this.bicycle = $event"
              (partSelect)="this.part = $event"
            ></app-warranty-leasing>
          }

          <!-- BATTERY CALLBACK -->
          @if (tabTypeSelected === 'REC_BATT') {
            <app-warranty-battery-callback
              #callback
              [currentArticle]="currentArticle"
              (partSelect)="selectPart($event)"
              [formGroup]="formGroup"
              [tabSelected]="tabTypeSelected"
            ></app-warranty-battery-callback>
          }
        </form>
      </div>
    </div>
    <div class="col-12 col-sm-5 px-5 px-sm-1 row align-content-start">
      @if (bicycle && formGroup.get('framenumber').enabled) {
        <h4>{{ "BICYCLE" | translate }}</h4>
        <app-article-card
          class="w-100 mb-3"
          [article]="bicycle"
          [useLazyLoad]="false"
        ></app-article-card>
      }
      @if (formGroup.get('articleCode').value && formGroup.get('articleCode').value !== '999999') {
        <h4>
          {{ "PART" | translate }} ({{
          descriptions[tabTypeSelected] | translate
          }})
        </h4>
        <app-article-card
          class="w-100"
          [article]="part"
          [useLazyLoad]="false"
          [autoShowDetails]="true"
          style="min-height: 560px;"
        ></app-article-card>
      }
      <ng-container>
        <div
          class="cms-content-container d-flex flex-column mt-3"
          [ngClass]="{
            'toggle-collapse': cmsCollapsed
          }"
          >
          <app-cms-page-content [pageId]="pageId"></app-cms-page-content>
          <button class="btn btn-link d-block" (click)="toggleCollapse()">
            {{ (cmsCollapsed ? "SHOW_MORE" :"SHOW_LESS") | translate }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="modal-footer">
  @if (validated && !formGroup.valid) {
    <p class="text-danger text-end">
      {{ "REQUIRED_FIELDS_TEXT" | translate }}
    </p>
  }

  <span class="col-md-12 p-0 d-flex justify-content-between">
    <button
      class="btn btn-dark btn-lg float-left"
      (click)="modal.dismiss('cancel click')"
      >
      {{ "CLOSE" | translate }}
    </button>
    <div>
      @if (formGroup.get('framenumber').value) {
        <button
          class="btn btn-success btn-lg me-1"
          id="submitAnotherWizard"
          #sendButton
          [hidden]="!formGroup.get('articleValid').valid"
          [disabled]="loading"
          (click)="checkForm(true)"
          >
          {{ "ADD_AND_NEW" | translate }}
        </button>
      }
      <button
        class="btn btn-success btn-lg"
        id="submitWizard"
        #sendButton
        [hidden]="!formGroup.get('articleValid').valid"
        [disabled]="loading"
        (click)="checkForm()"
        >
        {{ "SAVE" | translate }}
      </button>
    </div>
  </span>
</div>
